import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "../lib/toast";

interface Options {
  waiting: boolean;
  onStop: () => void;
  baselineCount: number;
  intervalMs?: number;
  timeoutMs?: number;
}

/** Polling reativo enquanto espera draft novo aparecer.
 *  Para quando lista cresce (success) ou timeout.
 *
 *  Semântica: a cada tick lê o snapshot CORRENTE do cache (pré-refetch),
 *  então dispara invalidateQueries. O incremento só é detectado na tick
 *  seguinte. Aceitável pq intervalMs default 3s e draft demora 10-20s. */
export const useDraftPollingAfterGeneration = ({
  waiting,
  onStop,
  baselineCount,
  intervalMs = 3000,
  timeoutMs = 60_000,
}: Options) => {
  const qc = useQueryClient();
  useEffect(() => {
    if (!waiting) return;
    const startedAt = Date.now();
    const iv = setInterval(() => {
      const currentCount = qc.getQueryData<Array<unknown>>(["drafts"])?.length ?? 0;
      qc.invalidateQueries({ queryKey: ["drafts"] });
      if (currentCount > baselineCount) {
        onStop();
        clearInterval(iv);
        toast.success("Draft pronto");
      } else if (Date.now() - startedAt > timeoutMs) {
        onStop();
        clearInterval(iv);
      }
    }, intervalMs);
    return () => clearInterval(iv);
  }, [waiting, qc, baselineCount, intervalMs, timeoutMs, onStop]);
};
